var map = {
	"./adventure.svg": "721a",
	"./aginic-logo-white.svg": "d3e7",
	"./app-logo.svg": "2af0",
	"./blob1.svg": "ef71",
	"./blob2.svg": "3e87",
	"./blob3.svg": "01a3",
	"./blob4.svg": "0aa4",
	"./blob6.svg": "8fd5",
	"./blob7.svg": "1f8a",
	"./blob8.svg": "b2b7",
	"./close.svg": "bf37",
	"./demo-aidh.png": "053e",
	"./demo-browsr.png": "9b0b",
	"./demo-health-hub.png": "9aee",
	"./demo-image.svg": "86b8",
	"./demo-oqr.png": "f425",
	"./demo-retail.png": "c1f9",
	"./demo-school.png": "fc9a",
	"./demo-student.png": "6d39",
	"./demo-sunnyside.png": "6a3b",
	"./demo-waitlist-calculator.png": "b6c9",
	"./logo-browsr.svg": "7900",
	"./logo-health-hub.svg": "5696",
	"./logo-oqr.svg": "1ce7",
	"./logo-retail.svg": "b315",
	"./logo-school.svg": "bdf0",
	"./logo-student.svg": "8f36",
	"./logo-sunnyside.svg": "8cb6",
	"./logo-waitlist-calculator.svg": "f714",
	"./next-button.svg": "2c49",
	"./notch.svg": "9dd5",
	"./spinner.svg": "5c3d",
	"./ticket.svg": "ba2d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";